import type { FC, ReactNode } from 'react'
import type { RevealProps } from '@/types'

import { cn } from '@/lib/utils'
import { useReveal } from '@/hooks/use-reveal'

/**
 * Scroll-driven reveal. Mirrors the wall's name re-reveal beat:
 * `{ y: 14px, blur(6px) } → { y: 0, blur(0) }` over 0.5s, power3.out.
 */
export const Reveal: FC<RevealProps> = ({ children, className, delay = 0 }): ReactNode => {
    const { ref, shown } = useReveal<HTMLDivElement>()

    return (
        <div
            ref={ref}
            data-shown={shown}
            className={cn('fz-reveal', className)}
            style={{ transitionDelay: `${delay}s` }}
        >
            {children}
        </div>
    )
}
